/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", function () {
  $(".email-info").tooltip()

  return $(document).on("click", ".downloadCSV a", function (e) {
    if ($(this).hasClass("csv-email")) {
      return $(this).replaceWith(
        "<span>Your Student Activity CSV is generating. Please check your email.</span>"
      )
    } else {
      return $(this).replaceWith(
        "<span>Your Student Activity CSV is downloading.</span>"
      )
    }
  })
})
